import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {ArrayField, FieldReturn} from '../../types'

export const array = (props: ArrayField, mergeProps?: Partial<ArrayField>): FieldReturn =>
  field('array', mergeConfig('array', props, mergeProps))
